export default "__VITE_ASSET__C0I_M8Hz__"